import { v4 as uuid } from 'uuid';
import type { Notification, NotificationInput } from 'types/__generated__/graphql-global-types';

const buildNotification = ({
  autoClose,
  showCta,
  autoCloseDuration,
  errorCode,
  message,
  persist,
  title,
  type,
}: NotificationInput): Notification => ({
  __typename: 'Notification',
  id: uuid(),
  autoClose: autoClose ?? true,
  showCta: showCta ?? false,
  autoCloseDuration: autoCloseDuration ?? 10000,
  errorCode: errorCode ?? null,
  message,
  persist: persist ?? false,
  title,
  type: type ?? 'info',
});

export default buildNotification;
